import global from "./global.json";

export const nb = {
  global,
};
